import './InfiniteScrollLoader.css';

const InfiniteScrollLoader = ({ className = '' }) => {
  return (
    <div className={`infinite-scroll-loader ${className}`}></div>
  );
};

export default InfiniteScrollLoader;
